import { Converter } from '../types/converter';

export const viscosityDynamicConverter: Converter = {
  id: 'viscosityDynamic',
  name: 'Dynamic Viscosity Converter',
  icon: 'Droplets',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit
    { name: 'Pascal second', symbol: 'Pa*s', factor: 1 },
    { name: 'Kilogram-force second/square meter', symbol: 'kgf·s/m²', factor: 9.80665 },
    { name: 'Newton second/square meter', symbol: 'N·s/m²', factor: 1 },
    { name: 'Millinewton second/square meter', symbol: 'mN·s/m²', factor: 0.001 },
    { name: 'Dyne second/square centimeter', symbol: 'dyn·s/cm²', factor: 0.1 },
    
    // Poise and derivatives
    { name: 'Poise', symbol: 'P', factor: 0.1 },
    { name: 'Exapoise', symbol: 'EP', factor: 1e17 },
    { name: 'Petapoise', symbol: 'PP', factor: 1e14 },
    { name: 'Terapoise', symbol: 'TP', factor: 1e11 },
    { name: 'Gigapoise', symbol: 'GP', factor: 1e8 },
    { name: 'Megapoise', symbol: 'MP', factor: 1e5 },
    { name: 'Kilopoise', symbol: 'kP', factor: 1e2 },
    { name: 'Hectopoise', symbol: 'hP', factor: 1e1 },
    { name: 'Dekapoise', symbol: 'daP', factor: 1 },
    { name: 'Decipoise', symbol: 'dP', factor: 0.01 },
    { name: 'Centipoise', symbol: 'cP', factor: 0.001 },
    { name: 'Millipoise', symbol: 'mP', factor: 0.0001 },
    { name: 'Micropoise', symbol: 'µP', factor: 1e-7 },
    { name: 'Nanopoise', symbol: 'nP', factor: 1e-10 },
    { name: 'Picopoise', symbol: 'pP', factor: 1e-13 },
    { name: 'Femtopoise', symbol: 'fP', factor: 1e-16 },
    { name: 'Attopoise', symbol: 'aP', factor: 1e-19 },
    
    // Imperial/US units
    { name: 'Pound-force second/square inch', symbol: 'lbf·s/in²', factor: 6894.757293168 },
    { name: 'Pound-force second/square foot', symbol: 'lbf·s/ft²', factor: 47.88025898 },
    { name: 'Poundal second/square foot', symbol: 'pdl·s/ft²', factor: 1.488164 },
    { name: 'Gram/centimeter/second', symbol: 'g·cm/s', factor: 0.1 },
    { name: 'Slug/foot/second', symbol: 'sl·ft/s', factor: 47.88025898 },
    { name: 'Pound/foot/second', symbol: 'lb·ft/s', factor: 1.488164 },
    { name: 'Pound/foot/hour', symbol: 'lb/(ft·h)', factor: 0.000413379 }
  ]
};
